import { inlineView, PreviewButton } from "./Artifacts";
import { AttachmentView } from "./Attachments";
import type { PartRenderers } from "./MessageView";
import { Notice, ToolCallCard } from "./ToolCall";

export const chatRenderers: PartRenderers = {
  attachment: (p, key) => <AttachmentView key={key} id={p.id} name={p.name} mime={p.mime} />,
  codeAction: (lang, code) => <PreviewButton lang={lang} code={code} />,
  codeView: inlineView,
  tool_call: (p, key, messageId) => <ToolCallCard key={key} part={p} messageId={messageId} />,
  notice: (p, key) => <Notice key={key} text={p.text} />,
};
